<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="التي تم خلالها الموافقة على إحداث مكتب" />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="محافظة الفرع"
            :value="data.governorate_id ? data.governorate_id.name_ar :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="المنطقة"
            :value="data.sub_district_id ? data.sub_district_id.name_ar :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="العنوان التفصيلي"
            :value="data.address"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="رقم العقار"
            :value="data.real_estate_id ? data.real_estate_id.number :''"
            />
        </b-col>     
        <b-col md="4" cols="12">
            <info-card label="الخدمات المقدمة"
            :value="data.services"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card label="اللجنة الإدارية"
            :value="data.management_committee"
            />
        </b-col>    
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
  import InfoCard from "@/components/InfoCard.vue";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
    },
    data() {
        return {
            file: '',
        }
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>